// Put all the utils or reusable code in utils folder

export const containsRole = (rolearray, role) => {
    return rolearray?.indexOf(role) > -1 ? true : false;
}

export const isObjectEmpty = (objectName) => {
    return Object.keys(objectName)?.length === 0
}
